import { translate } from '@gig/magic-common';
import { ValidationDisplay, required, maxLength, containsNumber, isNonSHPostalCode, isValidCanadianPostalCode } from '@gig/magic-form-builder';

var isNonSHPostalCodeValidator = function (postCode, formData) {
    return isNonSHPostalCode(postCode, formData.country.value);
};
var isValidCanadianPostalCodeValidator = function (postCode, formData) {
    return isValidCanadianPostalCode(postCode, formData.country.value);
};
function postCode() {
    return {
        id: 'postcode',
        serverId: 'addrPostalCode',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step2-postcode',
        properties: {
            placeholder: translate('sign-up-step-two.postcode.placeholder'),
        },
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: required,
                message: translate('sign-up-step-two.postcode.required-error'),
            },
            {
                name: 'max-length',
                fn: maxLength(20),
                message: translate('sign-up-step-two.postcode.max-length-error'),
            },
            {
                name: 'containsNumber',
                fn: containsNumber,
                message: translate('sign-up-step-two.postcode.contains-number-error'),
            },
            {
                name: 'isNonSHPostalCode',
                fn: isNonSHPostalCodeValidator,
                message: translate('sign-up-step-two.postcode.error'),
                triggeringFields: ['country'],
            },
            {
                name: 'isValidCanadianPostalCode',
                fn: isValidCanadianPostalCodeValidator,
                message: translate('sign-up-step-two.postcode.canadian-postal-code-error'),
                triggeringFields: ['country'],
            },
        ],
    };
}

export { postCode };
